module.exports = __webpack_public_path__ + "media/images/pic/hero/sea-755b69c1b8b5c2ecad1669ac2d559924.png";